export default __webpack_public_path__ + "static/media/quarantine meter.6646c6f0.svg";